import { render, staticRenderFns } from "./side_nav.vue?vue&type=template&id=8590d934&scoped=true&"
import script from "./side_nav.vue?vue&type=script&lang=js&"
export * from "./side_nav.vue?vue&type=script&lang=js&"
import style0 from "./side_nav.vue?vue&type=style&index=0&id=8590d934&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8590d934",
  null
  
)

export default component.exports